import NeonHero from '../../components/NeonHero';
import FinancingBanner from '../../components/FinancingBanner';

export default function Programming() {
	return (
		<div>
			<NeonHero
				title="Programming & Tuning"
				subtitle="OEM coding, reflashes, key programming, and performance tuning with safety controls."
				primaryCta={{ label: 'Request Programming', href: 'https://realm.ubiquityauto.com/order/2dcf3188-0a07-4444-b5f8-065a5dc238bb?access_token=_ha6LYxaO-9HjbYZVCY7P21vuKFFRaQ5' }}
			/>

			<FinancingBanner />

			<section className="container py-12">
				<h2 className="text-2xl font-bold">Capabilities</h2>
				<ul className="mt-4 grid sm:grid-cols-2 gap-3 text-gray-700 list-disc list-inside">
					<li>ECU/TCU coding and reflashing</li>
					<li>Key & immobilizer programming</li>
					<li>Performance maps with monitoring</li>
					<li>OEM-aligned documentation and rollback</li>
				</ul>
				<div className="mt-10 grid md:grid-cols-3 gap-6">
					<div className="rounded-xl border bg-white p-6 shadow-sm">
						<h3 className="font-semibold">Process</h3>
						<ol className="mt-2 list-decimal list-inside text-gray-700 space-y-1">
							<li>Vehicle scan and baseline snapshot</li>
							<li>Programming/tune with safeguards</li>
							<li>Validation and road test</li>
							<li>Documentation and rollback path</li>
						</ol>
					</div>
					<div className="rounded-xl border bg-white p-6 shadow-sm">
						<h3 className="font-semibold">Financing</h3>
						<p className="mt-2 text-gray-700">Affirm/Klarna 0% APR for 12 months with approved credit.</p>
					</div>
					<div className="rounded-xl border bg-white p-6 shadow-sm">
						<h3 className="font-semibold">Timeline</h3>
						<p className="mt-2 text-gray-700">Coding: same-day. Custom tunes: typically 1–2 days.</p>
					</div>
				</div>
			</section>
		</div>
	);
}
